import { render, staticRenderFns } from "./AnimatedBackground.vue?vue&type=template&id=54988452&scoped=true&"
import script from "./AnimatedBackground.vue?vue&type=script&lang=js&"
export * from "./AnimatedBackground.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedBackground.vue?vue&type=style&index=0&id=54988452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54988452",
  null
  
)

export default component.exports